import { icon, Icon } from '../lib/fa-icons.js';
import Widget from "./base.js";
import { NewsletterInTOCBig } from './newsletter-in-toc-big.js';

function watchScrollForToTop() {
	const tocEl = document.querySelector('.TableOfContentsBig');
	const toTopBtn = document.querySelector('.js_to-top');
	if (!tocEl || !toTopBtn) return;

	let ticking = false;
	const scrollWatch = () => {
		if (ticking) return;
		ticking = true;
		setTimeout(() => {
			const tocBottom = tocEl.getBoundingClientRect().bottom;
			if (tocBottom < 0) {
				toTopBtn.classList.remove('--hidden');
			} else {
				toTopBtn.classList.add('--hidden');
			}
			ticking = false;
		}, 500);
	};

	window.addEventListener('scroll', scrollWatch, { passive: true });
	scrollWatch();
}


export class TableOfContentsBig extends Widget {
	static __json_props = ['toc'];

	componentWillMount() {
		this.state.tocId = `toc-${Math.random().toString(36).substr(2, 9)}`;
		this.state.expand = false;
		this.toggleCollapsed = this.toggleCollapsed.bind(this);
	}

	componentDidMount() {
		if (this.props.enable) {
			// The TOC list comes from the server (tpm_post_toc() in
			// inc/post-toc.php), built from raw post_content so paywalled
			// sections stay listed even when the gate removes them from the DOM.
			const toc = Array.isArray(this.props.toc) ? this.props.toc : [];
			if (toc.length > 0) {
				this.setState({
					ready: true,
					toc,
				}, ()=>{
					// move totop button
					const toTopButton = document.querySelector(".js_to-top");
					if(toTopButton) {
						document.querySelector(".Primary").prepend(toTopButton);
						watchScrollForToTop();
					}

					//if height of .TableOfContentsBig is greater than half the viewport height, enable collapse
					const tocEl = document.querySelector('.TableOfContentsBig');
					if (tocEl.getBoundingClientRect().height > window.innerHeight / 2) {
						this.setState({canCollapse: true, collapsed: true});
					}
				});
			}
		}
	}

	componentDidUpdate() {
	}

	toggleCollapsed() {
		this.setState({collapsed: !this.state.collapsed});
	}

	renderList() {
		return (
			<ul class="TableOfContentsBig__List" id={`TableOfContentsBig__List ${this.state.canCollapse ? '--can-collapse' : ''}`}>
				{this.state.toc.map((item, index) => {
					if (this.state.canCollapse && this.state.collapsed && index >= 3) return null;
					return (<li class={`TableOfContentsBig__Item ${item.label ? '--has-label' : ''} ${item.author ? '--has-author' : ''}`} key={item.id}>
						<div class="TableOfContentsBig__ItemLeft">
							<div class="TableOfContentsBig__ItemLabel"><span>{item.label}</span></div>
							<a class="TableOfContentsBig__ItemTitle" href={`#${item.anchorId}`}>{item.title}</a>
						</div>
						{item.author && (
							<div class="TableOfContentsBig__ItemRight">
								{item.author}
							</div>
						)}
					</li>);
			})}
				{this.state.canCollapse && this.state.collapsed && (
					<div className="TableOfContentsBig__ListToggle" onClick={this.toggleCollapsed}>SHOW ({this.state.toc.length - 3}) MORE</div>
				)}

				{this.state.canCollapse && !this.state.collapsed && (
					<div  className="TableOfContentsBig__ListToggle" onClick={this.toggleCollapsed}>HIDE ({this.state.toc.length - 3})</div>
				)}
			</ul>
		);
	}


	renderContent() {
		if (!this.state.toc) return;

		return (
			<div className="TableOfContentsBig__Inner" id={this.state.tocId}>
				<a className={`TableOfContentsBig__ToTop --hidden js_to-top`} href={`#${this.state.tocId}`}><Icon name="list-ul" style="light" /></a>
				<div className="TableOfContentsBig__Head">
					<Icon name="list-ul" style="light" />
					<span className="TableOfContentsBig__HeadText">In This Issue</span>
					<div className="TableOfContentsBig__HeadSubscribe">
						<NewsletterInTOCBig category={this.props.category} cssClasses="center" />
					</div>
				</div>
				{this.renderList()}
				
				
			</div>
		);
	}
}
